const {Cookies} = window;

export function initP() {
  const
    COVER = 'portada',
    TEST_PREFIX = 'test',
    DOT = '.',
    ZERO = 0,
    Env = Object.freeze({
      DEVELOPMENT: 'des',
      STAGING:     'pre'
    }),
    _site    = window.__VOONTO__.lookup('vocento.site'),
    _data    = window.__VOONTO__.lookup('vocento.dtm.data'),
    _vocUid  = decodeURIComponent(Cookies.get('voc_uid')),
    _evolok  = Cookies.get('ev_sid'),
    {AdblockDetector, RSVP} = window
  ;

  var _cookie = _vocUid === 'undefined' ? {} : JSON.parse(_vocUid);

  window.voc_site = window.voc_site || _site.media;

  if (_site.env === Env.DEVELOPMENT || _site.env === Env.STAGING) {
    window.voc_site = `${TEST_PREFIX}-${window.voc_site}`;
  }

  window.ns_site    = window.voc_site;
  window.voc_se     = _data.seccion;
  window.voc_s1     = _data.subseccion1;
  window.voc_s2     = _data.subseccion2;
  window.voc_s3     = _data.subseccion3;
  window.voc_s4     = _data.subseccion4;
  window.voc_tn     = _data.titular;
  window.voc_tc     = _data.tipoContenido;
  window.voc_ed     = _data.edicion;
  window.voc_au     = _data.firmaAutor;
  window.voc_or     = _data.origenContenido;
  window.voc_pr     = _data.tipoDominio;
  window.voc_fep    = _data.fechaPrimeraPublicacion;
  window.voc_fem    = _data.fechaModificacion;
  window.voc_pl     = _data.plataformaContenido;
  window.voc_pu     = _data.sistemaPublicacion;
  window.voc_usrid  = _cookie.uid || '';
  window.voc_tusr   = window.__VOONTO__.getUserType();
  window.voc_usrcp  = _cookie.zip || '';
  window.voc_usrgen = _cookie.gender || '';
  window.voc_usrag  = _cookie.age || '';
  window.voc_ate    = ''; // FIXME
  window.voc_idi    = _data.idioma;
  window.voc_ho     = _data.origenPortada;
  window.voc_name   = _concat([
    window.voc_se,
    window.voc_s1,
    window.voc_s2,
    window.voc_s3,
    window.voc_s4,
    window.voc_tn
  ], DOT);
  window.ns_http_status = ''; // FIXME
  window.voc_adp = ZERO;
  window.voc_usrser = _cookie.dataRegistrationService || '';
  window.voc_usrsvs = _cookie.dataServicesSsoGroup || '';
  window.voc_adb = ZERO;
  window.voc_krux = window.voc_krux || ZERO;
  window.voc_pw_pid    = _data.IDEvolok;
  window.voc_pw_meter  = _data.productoEvolok;
  window.voc_pw_count  = _data.nPaginasConsumidas;
  window.voc_pw_max    = _data.nPaginasPermitidas;
  window.voc_pw_result = _data.autorizacionContenido;
  window.voc_pw_cookie = _data.idCookieEvolok || _evolok;

  // FIXME: ask
  if (window.voc_pw_cookieMM) {
    window.voc_pw_cookie = window.voc_pw_cookieMM;
  }

  // NOTE: adbd enabled
  if ('AdblockDetector' in window) {
    let adbdCookie, url, re, results, nsMChannel, adbOrigin;

    return window.__VOONTO__.when('adbd:ready').then(function(hasAdblocker) {
      if (hasAdblocker) {
        adbdCookie = Cookies.get(AdblockDetector.Cookie.NAME);
        url        = window.location.href.toLowerCase();
        re         = new RegExp("[?&]ns_mchannel(=([^&#]*)|&|#|$)");
        results    = re.exec(url);

        // FIXME: only ppll?
        if (!adbdCookie && window.voc_se === COVER) {
          window.voc_adb = '1-popup';
        } else {
          window.voc_adb = `1-capa-${window.voc_tc}`;
        }

        if (results && results[2]) {
          nsMChannel = decodeURIComponent(results[2].replace(/\+/g, ' '));

          if (nsMChannel.length > 0) {
            adbOrigin = nsMChannel;
            nsMChannel = nsMChannel.split('-');
            if (nsMChannel[1] && (nsMChannel[1] == 'capa' || nsMChannel[1] == 'popup')) {
              window.voc_adb = adbOrigin;
            }
          }
        }
      }
    });
  } else {
    return RSVP.resolve();
  }
}

/* Private */

function _concat(items, char) {
  return items.filter((item) => !!item).join(char);
}



// WEBPACK FOOTER //
// ./src/legacy/voc-vars.js